// extracted by mini-css-extract-plugin
export default {"Container":"ContentContainer_Container__NVwwE"};